module.exports = __webpack_public_path__ + "static/media/5ed7a34272f4e5e57a74878b.154ce1e1.png";